module.exports = __webpack_public_path__ + "img/autonomous-vehicle.8075640b.png";